import { render, staticRenderFns } from "./StockBatchUpdate.vue?vue&type=template&id=71472b2e&scoped=true&"
import script from "./StockBatchUpdate.vue?vue&type=script&lang=js&"
export * from "./StockBatchUpdate.vue?vue&type=script&lang=js&"
import style0 from "./StockBatchUpdate.vue?vue&type=style&index=0&id=71472b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71472b2e",
  null
  
)

export default component.exports